<template>
  <settings-page-card>
    <template slot="title">
      <div class="px-4">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="title font-weight-bold">
            Restrictions
          </h5>

          <edit-password-modal
            :readonly="!canUpdatePageRestrictions"
            @submited="fechList" 
          />
        </div>
      </div>
    </template>

    <div class="px-4">
      <b-list-group v-if="!loading">
        <b-list-group-item
          v-for="password in passwords"
          :key="password.id"
        >
          <page-password
            :password="password"
            :readonly="!canUpdatePageRestrictions"
            @deleted="fechList"
          />
        </b-list-group-item>
      </b-list-group>

      <div
        v-else
        class="text-center py-5"
      >
        <b-spinner variant="primary" />
      </div>
    </div>
  </settings-page-card>
</template>

<script>
import SettingsPageCard from '../../layouts/dashboard/SettingsPageCard'
import {mapGetters, mapState} from 'vuex'
import PagePassword from '../../components/editor/components/PagePassword'
import EditPasswordModal from '../../components/editor/components/EditPasswordModal'
import {readonly} from 'vue'

export default {
  name: 'PageRestrictions',

  components: {EditPasswordModal, PagePassword, SettingsPageCard},

  data () {
    return {
      loading: true,
      passwords: []
    }
  },

  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdatePageRestrictions () {
      return this.checkPermissions('project_settings.page_restrictions.update')
    }
  },

  created () {
    this.fechList()
  },

  async mounted () {
    await this.$store.dispatch('projects/hasAccessToPage', 'project_settings.page_restrictions')
  },

  methods: {
    readonly,
    fechList () {
      axios.get(`api/projects/${this.project.id}/passwords`)
        .then(({data}) => {
          this.passwords = data.data.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
